/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_FailedInputs */

const en_settings_billing_cancel_failed = /** @type {(inputs: Settings_Billing_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to cancel subscription`)
};

const zh_settings_billing_cancel_failed = /** @type {(inputs: Settings_Billing_Cancel_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消订阅失败`)
};

/**
* | output |
* | --- |
* | "Failed to cancel subscription" |
*
* @param {Settings_Billing_Cancel_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_failed = /** @type {((inputs?: Settings_Billing_Cancel_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_cancel_failed(inputs)
	return zh_settings_billing_cancel_failed(inputs)
});
export { settings_billing_cancel_failed as "settings.billing.cancel_failed" }